import api from '@/lib/api'

export default {
  async getDhlGuides ({ dispatch }, { page = 1, search = '', limit = 20 } = {}) {
    try {
      const data = await api.getDhlGuidesAPI(page, search, limit)
      return data
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },

  async getDhlGuideQuote ({ dispatch }, { deliveryId }) {
    try {
      const data = await api.getDhlGuideQuoteAPI(deliveryId)
      return { success: true, payload: data.payload }
    } catch (error) {
      return { success: false, error: error.message }
    }
  },

  async generateDhlGuide ({ dispatch }, { deliveryId }) {
    try {
      const data = await api.generateDhlGuideAPI(deliveryId)
      if (data && data.success === false) {
        const msg = data.payload?.errorMessage || 'EnvíoClick devolvió un error al generar la guía'
        return { success: false, error: msg }
      }
      dispatch('addTemporalNotification', { type: 'success', message: 'Guía generada correctamente' })
      return { success: true, data }
    } catch (error) {
      return { success: false, error: error.message }
    }
  },

  async getProducts ({ commit, state, dispatch }, { page = 1, filter = 0, search = '', limit = 10, sortKey = 'price', sortOrder = 'desc', username = '', startDate = '', endDate = '', onlyGiver = false, isSold = false, tradeIn = false, zipCode = '', region = '' }) {
    try {
      let payload = await api.getProductsAPI(page, filter, search, limit, sortKey, sortOrder, username, startDate, endDate, onlyGiver, isSold, tradeIn, zipCode, region)
      return payload
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async getRegionOptions ({ dispatch }, q = '') {
    try {
      const { payload } = await api.getRegionOptionsAPI(q)
      return payload
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return []
    }
  },
  async getProductDetail ({ commit, state, dispatch }, { productId }) {
    try {
      let { success, payload, error = '' } = await api.getProductDetailAPI(productId)
      if (success) {
        return payload
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async editProduct ({ dispatch }, { productId, product }) {
    try {
      let { success, error = '' } = await api.editProductAPI(productId, product)
      if (success) {
        return success
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async deleteImageProduct ({ dispatch }, { productId, image }) {
    try {
      let { success, error = '' } = await api.deleteImageProductAPI(productId, image)
      if (success) {
        return success
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async uploadImageProduct ({ dispatch }, { productId, file, main }) {
    try {
      let { success, image, error = '' } = await api.uploadImageProductAPI(productId, file, main)
      if (success) {
        return { success, image }
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async changeStatusProduct ({ dispatch }, { productId, status }) {
    try {
      let { success, message = '', error = '' } = await api.changeStatusProductAPI(productId, { status })
      dispatch('addTemporalNotification', { type: success ? 'success' : 'danger', message: success ? message : error })
      return success
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async responseCommentProduct ({ dispatch }, { idComment, userId, productId, response }) {
    try {
      let { success, message = '', error = '' } = await api.responseCommentProductAPI(idComment, userId, productId, response)
      console.log('API Response:', { success, message, error })

      if (success) {
        dispatch('addTemporalNotification', {
          type: 'success',
          message: message || 'Respuesta enviada con éxito!'
        })
      } else {
        dispatch('addTemporalNotification', {
          type: 'danger',
          message: error || 'No se pudo enviar la respuesta.'
        })
      }
      return success
    } catch (error) {
      dispatch('addTemporalNotification', {
        type: 'danger',
        message: error.message || 'Error al tratar de enviar la respuesta.'
      })
      return false
    }
  },
  async changeCoverProduct ({ dispatch }, { productId, data }) {
    try {
      let { success } = await api.changeCoverAPI(productId, data)
      return success
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async deleteProductById ({ dispatch }, productId) {
    try {
      let payload = await api.deleteProductByIdAPI(productId)
      dispatch('addTemporalNotification', { type: 'success', message: payload.payload.message })
      return payload
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async removeProductById ({ dispatch }, productId) {
    try {
      let payload = await api.removeProductByIdAPI(productId)
      dispatch('addTemporalNotification', { type: 'success', message: payload.message })
      return payload
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async csvDownloadProducts ({ dispatch }, filters = {}) {
    try {
      const blob = await api.csvDownloadProductsAPI(filters)
      return blob
    } catch (error) {
      return false
    }
  },

  async updateProductVisibility (_, productId) {
    try {
      await api.updateProductVisibility(productId)
      return true
    } catch (error) {
      return false
    }
  },

  async publishProductC2C (_, { productId, price }) {
    try {
      await api.publishProductC2CAPI(productId, price)
      return true
    } catch (error) {
      return false
    }
  },

  async updateAdminDeliveryStatus (_, { deliveryId, field, value }) {
    try {
      await api.updateAdminDeliveryStatusAPI({ deliveryId, field, value })
      return true
    } catch (error) {
      return false
    }
  },

  async updateProductSold (_, { productId, sold, soldDate }) {
    try {
      await api.updateProductSoldAPI({ productId, sold, soldDate })
      return true
    } catch (error) {
      return false
    }
  },

  async updateProductDisable (_, { productId, disableStatus }) {
    try {
      await api.updateProductDisableAPI({ productId, disableStatus })
      return true
    } catch (error) {
      return false
    }
  },

  async getSaleProduct (_, productId) {
    try {
      let { payload } = await api.getSaleProductApi(productId)
      return payload
    } catch (error) {
      return false
    }
  },
  async getNotificationProduct ({ commit, state, dispatch }, { productId }) {
    try {
      let { success, payload, error = '' } = await api.getNotificationProductAPI(productId)
      if (success) {
        return payload
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async getDiagnostic ({ commit, state, dispatch }, { productId }) {
    try {
      let { success, payload, error = '' } = await api.getDiagnosticAPI(productId)
      if (success) {
        return payload
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async getReceiptImage ({ commit, state, dispatch }, { productId }) {
    try {
      let { success, payload, error = '' } = await api.getReceiptImageAPI(productId)
      if (success) {
        return payload
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async getAdminDelivery ({ commit, state, dispatch }, { deliveryId }) {
    try {
      let { success, payload, error = '' } = await api.getAdminDeliveryAPI(deliveryId)
      if (success) {
        return payload
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async getAdminHomePickup ({ commit, state, dispatch }, { productId }) {
    try {
      let { success, payload, error = '' } = await api.getAdminHomePickupAPI(productId)
      if (success) {
        return payload
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async getPropertySession ({ commit, state, dispatch }, { productId }) {
    try {
      let { success, payload, error = '' } = await api.getPropertySessionAPI(productId)
      if (success) {
        return payload
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async getPaymentImage ({ commit, state, dispatch }, { productId }) {
    try {
      let { success, payload, error = '' } = await api.getPaymentImageAPI(productId)
      if (success) {
        return payload
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async updateProductPreapproved ({ dispatch }, { productId }) {
    try {
      let { success, message = '', error = '' } = await api.updateProductPreapprovedAPI(productId)
      if (success) {
        return message || error
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async updateAditionalInformation ({ dispatch }, { productId, body }) {
    try {
      let { success, message = '', error = '' } = await api.updateAditionalInformationAPI(productId, body)
      dispatch('addTemporalNotification', { type: success ? 'success' : 'danger', message: success ? message : error })
      if (success) {
        return message || error
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async updateDegree ({ dispatch }, { productId, degree }) {
    try {
      let { success, message = '', error = '' } = await api.updateDegreeAPI(productId, degree)
      dispatch('addTemporalNotification', { type: success ? 'success' : 'danger', message: success ? message : error })
      if (success) {
        return message || error
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async updatePartnerDeduction ({ dispatch }, { productId, percentage }) {
    try {
      let { success, message = '', payload = null, error = '' } = await api.updatePartnerDeductionAPI(productId, percentage)
      dispatch('addTemporalNotification', { type: success ? 'success' : 'danger', message: success ? message : error })
      return success ? payload : false
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async validatePartnerDownPayment ({ dispatch }, { productId, amount }) {
    try {
      let { success, message = '', payload = null, error = '' } = await api.validatePartnerDownPaymentAPI(productId, amount)
      dispatch('addTemporalNotification', { type: success ? 'success' : 'danger', message: success ? message : error })
      return success ? payload : false
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },

  async updateProductProposal ({ dispatch }, { productId, amount }) {
    try {
      let { success, message = '', error = '' } = await api.updateProductProposalAPI(productId, amount)
      dispatch('addTemporalNotification', { type: success ? 'success' : 'danger', message: success ? message : error })
      return message || error
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async changeStatusProductReceipt ({ dispatch }, { productId }) {
    try {
      let { success, message = '', error = '' } = await api.changeStatusProductReceiptAPI(productId)
      dispatch('addTemporalNotification', { type: success ? 'success' : 'danger', message: success ? message : error })
      return message
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async changeStatusPaymentProduct ({ dispatch }, { productId }) {
    try {
      let { success, message = '', error = '' } = await api.changeStatusPaymentProductAPI(productId)
      dispatch('addTemporalNotification', { type: success ? 'success' : 'danger', message: success ? message : error })
      return message || error
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return error
    }
  },
  async changeStatusFinalizeProduct ({ dispatch }, { productId }) {
    try {
      let { success, message = '', error = '' } = await api.changeStatusFinalizeProductAPI(productId)
      dispatch('addTemporalNotification', { type: success ? 'success' : 'danger', message: success ? message : error })
      return message
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async changeStatusProductPaymentImage ({ dispatch }, { productId, fileImage }) {
    try {
      let { success, message = '', error = '' } = await api.changeStatusProductPaymentImageAPI(productId, fileImage)
      dispatch('addTemporalNotification', { type: success ? 'success' : 'danger', message: success ? message : error })
      return message || error
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async promoCodeDetail ({ commit, state, dispatch }, promotionCodeId) {
    try {
      let { success, payload, error = '' } = await api.promoCodeDetailAPI(promotionCodeId)
      if (success) {
        return payload
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async promoCodeList ({ commit, state, dispatch }, { page = 1, search = '' } = {}) {
    try {
      let { success, payload, totalPages, error = '' } = await api.promoCodeListAPI(page, search)
      if (success) {
        return { payload, totalPages }
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async createPromoCode ({ dispatch }, data) {
    try {
      let result = await api.createPromoCodeAPI(data)
      if (result.success) {
        dispatch('addTemporalNotification', { type: 'success', message: 'Código creado correctamente.' })
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: result.error })
      }
      return result
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async updatePromoCode ({ dispatch }, { id, data }) {
    try {
      let result = await api.updatePromoCodeAPI(id, data)
      if (result.success) {
        dispatch('addTemporalNotification', { type: 'success', message: 'Código actualizado correctamente.' })
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: result.error })
      }
      return result
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async deletePromoCode ({ dispatch }, id) {
    try {
      let result = await api.deletePromoCodeAPI(id)
      if (result.success) {
        dispatch('addTemporalNotification', { type: 'success', message: 'Código eliminado correctamente.' })
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: result.error })
      }
      return result
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async uploadPartnerLogo ({ dispatch }, file) {
    try {
      const result = await api.uploadPartnerLogoAPI(file)
      return result
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async getAdminAdditionalsFiles ({ commit, state, dispatch }, { productId }) {
    try {
      let { success, payload, error = '' } = await api.getAdminAdditionalsFilesAPI(productId)
      if (success) {
        return payload
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async uploadAdminAdditionalsFile (_, { productId, formData }) {
    try {
      await api.uploadAdminAdditionalsFileAPI({ productId, formData })
      return true
    } catch (error) {
      return false
    }
  },
  async getAdminUpsertFunnelTracking ({ commit, state, dispatch }, { productId }) {
    try {
      let { success, payload, error = '' } = await api.getAdminUpsertFunnelTrackingAPI(productId)
      if (success) {
        return payload
      } else {
        dispatch('addTemporalNotification', { type: 'danger', message: error })
        return {}
      }
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },
  async uploadAdminUpsertFunnelTracking (_, { productId, data }) {
    try {
      await api.uploadAdminUpsertFunnelTrackingAPI({ productId, data })
      return true
    } catch (error) {
      return false
    }
  },
  async patchAdminFunnelTracking ({ dispatch }, { productId, data }) {
    try {
      await api.patchAdminFunnelTrackingAPI({ productId, data })
      return true
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  }
}
